import { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IRouterProps } from '@interfaces/App.interface';
import { generateGlobalColumns, generateEntityColumn, TInheritedProps } from '@ts/storybook';
import { SwitchCell, IDataGridConfig } from '@ts/storybook';
import { WarningRuleState, IConfigComponent, CEventType, CWarningRule, IWarningRule } from '@ts/ui-models';

interface IWarningRulesProps<Multiple extends boolean> extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<Multiple>;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'WarningRule',
  aclId: 'WarningRule',
  entity: 'warningRule',
  fetchURL: '/api/v3/warningRule',
  mainClass: CWarningRule,
};

const WarningRules = <Multiple extends boolean>(props: IWarningRulesProps<Multiple>) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false, event: false, updatedAt: false },
    sortModel: [{ field: 'name', sort: 'asc' }],
  };

  const getColumns = useMemo((): GridColDef<IWarningRule>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    const listOptions: { label: string; value: string }[] = Object.entries(WarningRuleState).map(([key, value]) => ({
      label: key,
      value: value,
    }));
    const formatValueState = (value: boolean) => {
      return value ? 'ENABLED' : 'DISABLED';
    };
    return [
      globalCells.id(),
      globalCells.name(),
      generateEntityColumn(
        { field: 'eventType', headerName: 'Event Type' },
        { field: 'eventType', mainClass: CEventType },
        { inheritedProps }
      ),
      //generateSelectColumn('state', stateOptions),
      {
        field: 'state',
        type: 'singleSelect',
        headerName: 'State',
        valueOptions: listOptions,
        valueGetter: (value, row, column) => {
          return row.state === 'ENABLED';
        },
        renderCell: params => SwitchCell({ ...params, ...mixProps, formatValue: formatValueState }),
      },
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      dataGridConfig={config}
      configComponent={configComponent}
      columns={getColumns}
      //Extra data
      inheritedProps={props.inheritedProps}
      enabledFilters
      enabledSort
    />
  );
};

export default WarningRules;
